'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var accounts = require('../accounts.cjs');
var Listing = require('../models/Listing.cjs');
var Operation = require('../../../types/Operation.cjs');

// -----------------
// Operation
// -----------------

const Key = 'FindListingByReceiptOperation';

/**
 * Finds a Listing by its receipt address.
 *
 * ```ts
 * const nft = await metaplex
 *   .auctionHouse()
 *   .findListingByReceipt({ receiptAddress, auctionHouse };
 * ```
 *
 * @group Operations
 * @category Constructors
 */
const findListingByReceiptOperation = Operation.useOperation(Key);

/**
 * @group Operations
 * @category Types
 */

/**
 * @group Operations
 * @category Handlers
 */
const findListingByReceiptOperationHandler = {
  handle: async (operation, metaplex, scope) => {
    const {
      receiptAddress,
      auctionHouse
    } = operation.input;
    const account = accounts.toListingReceiptAccount(await metaplex.rpc().getAccount(receiptAddress, scope.commitment));
    scope.throwIfCanceled();
    const lazyListing = Listing.toLazyListing(account, auctionHouse);
    return metaplex.auctionHouse().loadListing({
      lazyListing,
      ...operation.input
    }, scope);
  }
};

exports.findListingByReceiptOperation = findListingByReceiptOperation;
exports.findListingByReceiptOperationHandler = findListingByReceiptOperationHandler;
//# sourceMappingURL=findListingByReceipt.cjs.map
